module.exports = __webpack_public_path__ + "static/wallpaper-f6faa4cc49534f1cd2b6fefd66b68226.jpg";